export const EVENT_STATUS_TABS = Object.freeze([
  { key: "all", label: "전체" },
  { key: "ongoing", label: "진행중" },
  { key: "closed", label: "마감" },
]);

export function normalizeEventStatus(status) {
  return EVENT_STATUS_TABS.some((tab) => tab.key === status) ? status : "all";
}

export function normalizeEventBranch(branch) {
  return String(branch || "")
    .replace(/^MY\s*STUDIO\s*/i, "")
    .replace(/^베이비파스텔\s*/i, "")
    .trim();
}

export function isAllBranchEvent(event) {
  const branch = normalizeEventBranch(event?.branchName || event?.branch);
  return branch === "전 지점" || branch === "전체 지점";
}

export function filterEventsByStatus(events, status) {
  const normalizedStatus = normalizeEventStatus(status);
  if (normalizedStatus === "all") return [...(Array.isArray(events) ? events : [])];
  return (Array.isArray(events) ? events : []).filter((event) => (
    normalizedStatus === "closed" ? event?.status === "closed" : event?.status !== "closed"
  ));
}

export function sortOngoingEvents(events) {
  const urgencyDays = (event) => {
    const match = String(event?.statusLabel || "").match(/D-(\d+)/i);
    return match ? Number(match[1]) : Number.POSITIVE_INFINITY;
  };

  return [...(Array.isArray(events) ? events : [])].sort((left, right) => (
    urgencyDays(left) - urgencyDays(right)
  ));
}

export function rankStoreEvents(events, myBranch) {
  return [...(Array.isArray(events) ? events : [])].sort((left, right) => {
    const branchScore = (event) => {
      const exactBranch = normalizeEventBranch(event?.branchName || event?.branch) === normalizeEventBranch(myBranch);
      if (exactBranch) return 0;
      if (isAllBranchEvent(event)) return 1;
      return 2;
    };
    const urgencyScore = (event) => (event?.status === "ending" ? 0 : 1);

    return branchScore(left) - branchScore(right)
      || urgencyScore(left) - urgencyScore(right)
      || Number(Boolean(left?.isApplied)) - Number(Boolean(right?.isApplied));
  });
}
